import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "49.899",
      width: "50",
      viewBox: "0 0 50 49.899"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M50 47.4L33.94 31.29c2.738-3.29 4.36-7.546 4.36-12.156 0-4.66-1.824-9.422-5.016-12.97-3.596-4-8.612-6.18-14.083-6.18C8.61-.016 0 8.597 0 19.134s8.56 19.15 19.148 19.15c4.66 0 8.916-1.673 12.26-4.46l16.058 16.06L50 47.4zM3.546 19.1c0-8.612 7.04-15.603 15.603-15.603 7.495 0 15.6 5.978 15.6 15.603 0 8.612-6.99 15.603-15.603 15.603-8.562 0-15.604-6.99-15.604-15.603z"
    }))
  );
});